import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const BorderRadiusUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const BorderRadiusValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const BorderRadiusTokenData = tokenAliasOrValue(BorderRadiusValue);

export type BorderRadiusUnit = z.infer<typeof BorderRadiusUnit>;
export type BorderRadiusValue = z.infer<typeof BorderRadiusValue>;
export type BorderRadiusTokenData = z.infer<typeof BorderRadiusTokenData>;
